export type OrarioItem = { day: number | '*', from: string, to: string };

export function parseOrariString(orari: string): OrarioItem[] {
  if (!orari || typeof orari !== 'string') return [];
  return orari.split(',').map(raw => {
    const [dayPart, timePart] = raw.split('|');
    if (!dayPart || !timePart) return null;
    const [from, to] = timePart.split('-');
    return {
      day: dayPart === '*' ? '*' : parseInt(dayPart, 10),
      from: from?.trim() || '',
      to: to?.trim() || ''
    };
  }).filter(Boolean) as OrarioItem[];
}
